<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" />
    </div>
</template>

<script>
export default {
  name: 'CellRendererActions',
  methods: {
    editRecord () {
      const ruta = `/configuracion/empresas/editar/${this.params.data.id}`
      this.$router.push(ruta).catch(() => {})
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmación de borrado',
        text: `¿Seguro que quiere eliminar la empresa con ID "${this.params.data.id}"?`,
        accept: this.deleteRecord,
        acceptText: 'Eliminar'
      })
    },
    deleteRecord () {
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      this.$store.dispatch('empresasStore/deleteEmpresa', this.params.data.id)
        .then(()   => { this.showDeleteSuccess() })
        .catch(error => { this.showDeleteError(error) })
    },
    showDeleteSuccess () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: 'Registro eliminado',
        text: 'La empresa seleccionada ha sido eliminada correctamente'
      })
    },
    showDeleteError (error) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: 'Error eliminando la empresa',
        text: error
      })
    }
  }
}
</script>
